import React, { useState } from "react";
import { Card, CardBody, Row, Col, Button, Modal, ModalBody } from "reactstrap";
import { X } from "react-feather";

function ProductCard(props) {
  const { item, onRemove, submitLoading } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

  return (
    <>
      <Card style={{ borderRadius: 8, marginTop: 10, border: "1px solid #7BC002", boxShadow: "none" }}>
        <CardBody style={{ padding: 10 }}>
          <div style={{ marginTop: 10 }}>
            <Row className="justify-content-between">
              <Col xs={3}>
                <div>
                  <img
                    width={50}
                    height={50}
                    className="img-thumbnail"
                    src={item.image || '/noImage.png'}
                    alt={item.name || ""}
                    onClick={toggleModal}
                    style={{ cursor: "pointer", padding:0 }}
                  />
                </div>
              </Col>
              <Col xs={9} style={{ textAlign: "left", fontSize: 14 }}>
                <p style={{margin:0}}><span><strong>Name : </strong></span> {item.title || item.name}</p>
                <p style={{margin:0}}><span><strong>Size : </strong></span> {item.size}</p>
                <p style={{margin:0}}><span><strong>Colour :</strong></span> {item.colour}</p>
              </Col>
            </Row>
          </div>
          <Button
            close
            onClick={onRemove}
            disabled={submitLoading}
            style={{ position: "absolute", top: 5, right: 5, backgroundColor: "#fff", borderRadius: "50%", padding: 2, zIndex: 1 }}
          />
        </CardBody>
      </Card>

      <Modal isOpen={modalOpen} toggle={toggleModal} centered>
        <ModalBody className="text-center">
          <img src={item.image} alt={item.name || '/noImage.png'} style={{ maxWidth: "100%", maxHeight: "80vh" }} />
        </ModalBody>
      </Modal>
    </>
  );
}

export default ProductCard;
